export enum NoteErrorCode {
  CannotAssignAdminWithoutAccess = 'cannot_assign_admin_without_access',
}

export enum EntityStoreKey {
  RecentNotes = 'recentNotes',
}

export interface RecentNotesParams {
  limit: number;
  page: number;
}
